var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.795,
    height: 16.653,
    viewBox: "0 0 21.795 16.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(-8.1 -13.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M27.984,30.453H10.011A1.923,1.923,0,0,1,8.1,28.542V15.711A1.923,1.923,0,0,1,10.011,13.8H27.984a1.923,1.923,0,0,1,1.911,1.911V28.542A1.923,1.923,0,0,1,27.984,30.453ZM9.966,15.029a.622.622,0,0,0-.637.637V28.5a.622.622,0,0,0,.637.637H27.938a.622.622,0,0,0,.637-.637V15.666a.622.622,0,0,0-.637-.637Z",
    transform: "translate(0 0)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M22.423,24.505a2.5,2.5,0,0,1-2.5-2.5,2.5,2.5,0,1,1,2.5,2.5Zm0-3.868a1.32,1.32,0,1,0,1.32,1.32A1.32,1.32,0,0,0,22.423,20.638Zm3.413,12.695L15.325,23.459,9.319,29.01,8.5,28.145l6.825-6.325,11.33,10.647-.819.865",
    transform: "translate(-0.218 -3.106)",
    fill: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M45.189,37.468l-3.5-2.821-2.912,2.412L38,36.1l3.686-3,4.232,3.458-.728.91",
    transform: "translate(-16.295 -10.518)",
    fill: "#d0d0d0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanners);
export default __webpack_public_path__ + "static/media/banners.d45d17428e22030b0d21120449a0a11f.svg";
export { ForwardRef as ReactComponent };